/*
 * @Author: Json Chen
 * @Date: 2022-05-31 09:51:02
 * @LastEditTime: 2022-06-06 15:58:38
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Analytics/ReportSubscription/ReportSubscriptionDetail/SendTo/index.tsx
 */
/*
 * @Author: Teemo Ding
 * @Date: 2022-04-19 10:31:26
 * @LastEditTime: 2022-05-06 13:38:01
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Analytics/ReportSubscription/ReportSubscriptionDetail/SendTo/index.tsx
 */
import { Input, Label } from '@/src/components/Antd';
import { getNextSendTime } from '@/src/request/analytics/reportSubscription';
import { unique } from '@/src/tools/helper';
import { useRequest } from 'ahooks';
import { Form } from 'antd';
import { cloneDeep } from 'lodash';
import React, { Fragment } from 'react';
import Tags from 'src/components/Tags/Tags';
import { useI18n } from 'src/hooks/useRouterChange';
import SectionWrapper from 'src/pages/SalesCannelVersion/Components/SectionWrapper';
import {
  i18nGet,
  replaceI18nVariables,
  handleOnFormatStoreTimeAndDate,
} from 'src/tools/tools';
import { ITime } from 'src/types/common/report';
import SendTime from '../../Components/SendTime';
import css from '../css.module.less';
const regBreak = new RegExp(/[,｜\s｜，|,]+/g);

const SendTo = ({
  form,
  nextSendTime,
  setNextSendTime,
  timeZone,
  lastSentTime,
  disabled,
}) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { run: _getNextSendTime } = useRequest(
    (data) => getNextSendTime(data),
    {
      manual: true,
      onSuccess: (res) => {
        setNextSendTime(handleOnFormatStoreTimeAndDate(res));
      },
    },
  );

  const tagClose = (e, index) => {
    const emailList = form.getFieldValue('emails');
    const emailListCopy = cloneDeep(emailList);
    emailListCopy.splice(index, 1);
    form.setFieldsValue({ emails: unique(emailListCopy) });
  };
  const handleEmailChange = (value) => {
    if (regBreak.test(value)) {
      handleEmailBreak(value);
    }
  };
  const handleEmailBreak = (email) => {
    if (email) {
      const emailList = form.getFieldValue('emails');
      const emailListCopy = cloneDeep(emailList);
      emailListCopy.push(email);
      form.setFieldsValue({ email: '', emails: unique(emailListCopy) });
    }
  };

  const handleEmailPressEnter = ({ target: { value } }) => {
    handleEmailBreak(value);
  };
  const handleTimeChange = (value) => {
    if (value.time) {
      _getNextSendTime(value);
    }
  };

  return (
    <Fragment>
      <SectionWrapper
        containerClassName={css.sectionContainer}
        titleClassName={css.titleClassName}
        title={getI18n(
          'reportSubscription.reportSubscriptionDetail.sendTo.title',
        )}>
        <Form.Item
          noStyle
          shouldUpdate={(prevValues, curValues) =>
            prevValues.emails !== curValues.emails
          }>
          {({ getFieldValue }: any) => (
            <Form.Item
              name='email'
              className={css.email}
              rules={[
                {
                  validator: async (x, value) => {
                    if (
                      !value &&
                      !(form.getFieldValue('emails') || []).length
                    ) {
                      return Promise.reject(
                        new Error(
                          getI18n(
                            'reportSubscription.reportSubscriptionDetail.sendTo.email_reject',
                          ),
                        ),
                      );
                    }
                  },
                },
              ]}
              label={<Label title={getI18n('general.email')} />}
              labelCol={{ span: 24 }}>
              <Input
                disabled={
                  (getFieldValue('emails') || []).length >= 10 || disabled
                }
                onChange={handleEmailChange}
                onPressEnter={handleEmailPressEnter}
                size='large'
              />
            </Form.Item>
          )}
        </Form.Item>
        <Form.Item name='emails' valuePropName='data' initialValue={[]}>
          <Tags onClose={tagClose} disabled={disabled} />
        </Form.Item>
      </SectionWrapper>
      <Form.Item
        name='sendTime'
        className={css.sendTime}
        label={
          <Label
            title={replaceI18nVariables(
              getI18n(
                `reportSubscription.reportSubscriptionDetail.sendTo.sendtime_title`,
              ),
              timeZone,
            )}
          />
        }
        rules={[
          {
            validator: async (x, value) => {
              const { unit, last, day, time } = value || {};
              if (
                !unit ||
                (unit === ITime.Months &&
                  !((last || last === false) && (day || day === 0) && time)) ||
                (unit === ITime.Weeks && (!time || day === undefined)) ||
                (unit === ITime.Days && !time)
              ) {
                return Promise.reject(
                  new Error(
                    getI18n(
                      'reportSubscription.reportSubscriptionDetail.sendTo.sendtime_error',
                    ),
                  ),
                );
              }
            },
          },
        ]}
        labelCol={{ span: 24 }}>
        <SendTime onChange={handleTimeChange} disabled={disabled} />
      </Form.Item>
      <Form.Item
        noStyle
        shouldUpdate={(prevValues, curValues) =>
          prevValues.sendTime !== curValues.sendTime
        }>
        {({ getFieldValue }: any) => (
          <div className={css.sent}>
            <div className={css.sentItem}>
              <h4>
                {replaceI18nVariables(
                  getI18n(
                    `reportSubscription.reportSubscriptionDetail.sendTo.last_h4`,
                  ),
                  timeZone,
                )}
              </h4>
              <p>{lastSentTime || '-'}</p>
            </div>
            <div>
              <h4>
                {replaceI18nVariables(
                  getI18n(
                    `reportSubscription.reportSubscriptionDetail.sendTo.next_h4`,
                  ),
                  timeZone,
                )}
              </h4>
              <p>{nextSendTime || '-'}</p>
            </div>
          </div>
        )}
      </Form.Item>
    </Fragment>
  );
};

export default SendTo;
